c3site.fs = {
    'autocomplete':{
        'init': function(input){
            $(input).on('input', function(){c3site.fs.autocomplete.get(input)});
            $(input).on('blur', function(){c3site.fs.autocomplete.hide('.input-fs-autocomplete')});
            $(input).on('focus', function(){c3site.fs.autocomplete.show('.input-fs-autocomplete')});
        },
        'get': function(input) {

            if (input.value.length >= 3) {
                
                $.ajax(
                {
                    type: 'GET',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/finstat-autocomplete?query=' + input.value,
                    dataType: 'json',
                    success: function(data) {
                        try{
                            if (data.company && data.company.length){

                                /* Vytvorenie ponuky moznosti vyberu z dat vrfatenych z autocomplete sluzby podla vyplneneho mena firmy */
                                if ($('.input-fs-autocomplete').length){
                                    $('.input-fs-autocomplete__menu').empty();
                                } else {
                                    $( `<div class="input-fs-autocomplete"><div class="input-fs-autocomplete__menu"></div></div>` ).insertAfter($(input));
                                };

                                var companies = data.company;
                                companies.forEach(function(company){
                                    $('.input-fs-autocomplete__menu').append(`
                                        <button type="button" class="input-fs-autocomplete__item" 
                                            data-ico="${company.Ico}"
                                            onclick="c3site.fs.autocomplete.select(this)" 
                                        >
                                            ${company.Name}<br>
                                            ${company.City}<br>
                                            <small>IČO:&nbsp;<b>${company.Ico}</b></small>
                                        </button>
                                    `)
                                });
                                c3site.fs.autocomplete.show('.input-fs-autocomplete');
                            };

                        }catch(e) {
                            cyclone3.log('error ' + e);
                        }
                    }
                });
            } else {
                c3site.fs.autocomplete.hide('.input-fs-autocomplete');
            }
        },
        'getorg': function(ico) {

            if (ico) {
                
                $.ajax(
                {
                    type: 'GET',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/finstat-getorg?ICO=' + ico,
                    dataType: 'json',
                    success: function(data) {
                        try{
                            if (data.ICO && data.ICO.length){
                                /* naplnenie poli formularov vratenymi datami zo sluzby getorg */
                                
                                /* akciove-pneumatiky - registracia */
                                if (window.location.href.indexOf("akciove-pneumatiky.sk/register") > -1) {
                                    $('#firm_name').val(data.name);
                                    $('#ico').val(data.ICO);
                                    $('#dic').val(data.Dic);
                                    /* ak ma IC DPH tak je platca DPH inak nie je */
                                    if (data.IcDPH) {
                                        $('#icdph').show();
                                        $('[name="vat"]').val('platcaDPH');
                                    } else {
                                        $('#icdph').hide();
                                        $('[name="vat"]').val('neplatcaDPH');
                                    };
                                    $('#icdph').val(data.IcDPH);
                                };

                                /* akciove-pneumatiky - order-data */
                                if (window.location.href.indexOf("akciove-pneumatiky.sk/order-data") > -1) {
                                    $('#reg_name').val(data.name);
                                    $('[name="reg_ico"]').val(data.ICO);
                                    $('#reg_dic').val(data.Dic);
                                    $('#reg_zip').val(data.ZIP);
                                    $('#reg_street').val(data.Street + ' ' + data.StreetNumber);
                                    $('#reg_city').val(data.City);
                                    /* ak ma IC DPH tak je platca DPH inak nie je */
                                    if (data.IcDPH) {
                                        $('#platcaDPH').prop( "checked", true );
                                        $('.company_icdph').show();
                                    } else {
                                        $('#neplatcaDPH').prop( "checked", true );
                                        $('.company_icdph').hide();
                                    };
                                    $('[name="reg_icdph"]').val(data.IcDPH);
                                };

                                /* pneuservis.sk - registracia */
                                if (window.location.href.indexOf("pneuservis.sk/register") > -1) {
                                    $('#company').val(data.name);
                                    $('#ico').val(data.ICO);
                                    $('#dic').val(data.Dic);
                                    $('#icdph').val(data.IcDPH);
                                    $('#street').val(data.Street);
                                    $('#street_num').val(data.StreetNumber);
                                    $('#zip').val(data.ZIP);
                                    $('#city').val(data.City);
                                    $('#country').val('Slovensko');
                                };

                                c3site.fs.autocomplete.hide('.input-fs-autocomplete');
                            };

                        }catch(e) {
                            cyclone3.log('error ' + e);
                        }
                    }
                });
            } else {
                /* nemam data */
            }
        },
        'hide': function(cssclass){
            $(cssclass).delay(300).hide(0);
        },
        'show': function(cssclass){
            $(cssclass).show();
        },
        'select': function(element){
        
            /* zavolanie sluszby pre vratenie udajov o vybranej firme z moznosti autocomplete podla ICO*/
            c3site.fs.autocomplete.getorg(element.dataset.ico);
            c3site.fs.autocomplete.hide('.input-fs-autocomplete');
        },
    } 
}